import React, { Fragment, useEffect, useState } from 'react';
import Navbar from '../../components/Navbar'
import PageTitle from '../../components/pagetitle'
import BlogList from '../../components/BlogList'
import Footer from '../../components/footer'
import Scrollbar from '../../components/scrollbar'
import Logo from '../../images/logo.svg'
import { useTranslation } from 'react-i18next';
import { useFetch } from '../../hooks/useFetch';
import { fetchBlogs } from '../../api/api';
import { useSearchParams } from 'react-router-dom';

const BlogPage = () => {
    const { t, i18n } = useTranslation();
    const { data, isLoading, error } = useFetch(['blogs'], fetchBlogs);
    const [blogs, setBlogs] = useState([]);
    const [paginatedBlogs, setPaginatedBlogs] = useState([]);
    const [filters, setFilters] = useState({ category: "all", tags: "all" });
    const [searchParams, setSearchParams] = useSearchParams();
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [categories, setCategories] = useState([]);
    const [tags, setTags] = useState([]);
    useEffect(() => {
        if (!data) return;
        const fetchedBlogs = data?.data?.data || [];
        setBlogs(fetchedBlogs); // Store the full dataset
        setCurrentPage(1); // Reset to page 1 when data changes
        const extractUniqueValues = (key) => {
            return Array.from(new Set(data?.data?.data.flatMap((course) => course.data[key])));
        };

        setCategories(extractUniqueValues("categories"));
        setTags(extractUniqueValues("tags"));
    }, [data]);
    // Sync filters with URL parameters
    useEffect(() => {
        const urlFilters = {
            category: searchParams.get("category") || "all",
            tags: searchParams.get("tags") || "all",
        };
        setFilters(urlFilters);
    }, [searchParams]);

    useEffect(() => {
        // Apply filters before pagination
        const filteredBlogs = blogs.filter((blog) => {
            const { category, tags } = filters;

            return (
                (category === "all" || blog.data.categories.includes(category)) &&
                (tags === "all" || blog.data.tags.includes(tags))
            );
        });

        const startIndex = (currentPage - 1) * itemsPerPage;
        const endIndex = startIndex + itemsPerPage;
        setPaginatedBlogs(filteredBlogs.slice(startIndex, endIndex));
    }, [blogs, currentPage, itemsPerPage, filters]);

    const totalPages = Math.ceil(
        blogs.filter((blog) => {
            const { category, tags } = filters;
            return (
                (category === "all" || blog.data.categories.includes(category)) &&
                (tags === "all" || blog.data.tags.includes(tags))
            );
        }).length / itemsPerPage
    );

    const handlePageChange = (page) => setCurrentPage(page);

    const handleFilter = (name, value) => {
        setFilters((prevFilters) => ({
            ...prevFilters,
            [name]: value,
        }));
        setCurrentPage(1); // Reset to the first page
    };


    return (
        <Fragment>
            <Navbar Logo={Logo} />
            <PageTitle pageTitle={t('pageTitles.blog')} pagesub={t('pageTitles.blogSub')} />
            <BlogList categories={categories} tags={tags} paginatedBlogs={paginatedBlogs} handlePageChange={handlePageChange} handleFilter={handleFilter} currentPage={currentPage} totalPages={totalPages} />
            <Footer ftClass={'wpo-site-footer-s2'} />
            <Scrollbar />
        </Fragment>
    )
};
export default BlogPage;

